import { Dialog } from "primereact/dialog";
import { Button } from "primereact/button";
import { IWebSite } from "../../models/WebSite";
import { useForm } from "react-hook-form"
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import { useEffect, useState } from "react";
import { Fetch } from "../../shared/Fetch";
import { JVInput } from "../../shared/JVInput";
import { JVDropdown } from "../../shared/JVDropdown";
import { Accordion, AccordionTab } from "primereact/accordion";
import { ITarget } from "./ITarget";
import { EmptyTarget } from "./EmptyTarget";
import { ILogin } from "../../models/Login";

const schema = yup.object({
    reporting_Period: yup.number().required("Reporting Period is required").nullable(),
    sub: yup.number().nullable().typeError("SUB Target Value Required"),
    req: yup.number().nullable().typeError("REQ Target Value Required"),
    ecs: yup.number().required("ESC Target Value Required").typeError("ESC Target Value Required").nullable(),
    eci: yup.number().required("ECI Target Value Required").typeError("ECI Target Value Required").nullable(),
    po: yup.number().required("PO Target Value Required").typeError("PO Target Value Required").nullable(),
});

interface Iprops {
    singleData: any,
    open: boolean,
    hideDialog: () => void,
    toast: any,
    reload: boolean,
    setReload: (is: boolean) => void
}

const DropDown: { name: string, value: number }[] = [
    { name: "Monthly", value: 1 },
    // { name: "Quaterly", value: 2 },
    // { name: "Half Yearly", value: 3 },
    // { name: "Annualy", value: 4 },
];

const Report_DropDown: { name: string, value: number }[] = [
    { name: "SUB", value: 1 },
    { name: "ECI", value: 2 },
    { name: "ECS", value: 3 },
    { name: "PO", value: 4 },
];

export const Form = (props: Iprops) => {
    const [saveDis,setSaveDis] = useState(false);

    let _role: Array<number> = [];
    const loginObj: ILogin = JSON.parse(sessionStorage.getItem('auth') + '');
    loginObj.roles.forEach(role => {
        _role.push(role.role_ID);
    });

    const { control, handleSubmit, formState: { errors }, reset } = useForm<ITarget>({
        resolver: yupResolver(schema),
        defaultValues: props.singleData,
        shouldFocusError: false
    });

    useEffect(() => {
        reset(props.singleData);
    }, [props.singleData])

    const saveToDB = async (body: ITarget) => {
        const method = props.singleData.target_Id ? "PUT" : "POST";
        const message = props.singleData.target_Id ? "Updated Successfully" : "Added Successfully";

        const response = await Fetch("Tbl_Targets", method, body, null, props.toast);

        if (response) {
            props.toast.current.show({ severity: 'success', detail: message, life: 3000 });
            props.setReload(!props.reload);
            setSaveDis(false);
            onHide();
        }
    }

    const onHide = () => {
        props.hideDialog();
        reset(EmptyTarget);
    }

    function onSubmit(data: ITarget) {
        setSaveDis(true);
        if ((_role.includes(2) || _role.includes(5)) && (data.req === null || data.req === undefined)) {
            props.toast.current.show({ severity: 'error', detail: "Please Enter REQ Target", life: 3000 });
        } else if ((_role.includes(3) || _role.includes(4)) && (data.sub === null || data.sub === undefined)) {
            props.toast.current.show({ severity: 'error', detail: "Please Enter SUB Target", life: 3000 });
        } else {
            saveToDB(data);
        }
    }

    return (
        <Dialog visible={props.open} style={{ width: '80vw' }} header="Target" modal className="p-fluid" onHide={onHide} maximizable>
            <form onSubmit={handleSubmit(onSubmit)} className="p-fluid formgrid grid" >
                <JVDropdown required column={3} label="Reporting Period" control={control} name="reporting_Period" options={DropDown} optionLabel="name" optionValue="value" placeholder="Select Reporting Period" error={errors.reporting_Period?.message} />
                {(_role.includes(3) || _role.includes(4) || _role.includes(1)) && ((props.singleData.reporting_Period != null && props.singleData.user_Type === "recruiter") ? true : props.singleData.reporting_Period === null) && <JVInput required type="number" column={3} label="SUB Target Value" control={control} name="sub" error={errors.sub?.message} />}
                {(_role.includes(2) || _role.includes(5) || _role.includes(1)) && ((props.singleData.reporting_Period != null && props.singleData.user_Type === "sales") ? true : props.singleData.reporting_Period === null) && <JVInput required type="number" column={3} label="REQ Target Value" control={control} name="req" error={errors.req?.message} />}
                <JVInput required column={3} label="ECS Target Value" control={control} name="ecs" error={errors.ecs?.message} />
                <JVInput required column={3} label="ECI Target Value" control={control} name="eci" error={errors.eci?.message} />
                <JVInput required column={3} label="PO Target Value" control={control} name="po" error={errors.po?.message} />
                <div className="col-12 md:col-12">
                    <Button className="field col-12 md:col-6 h-2rem " label="SAVE" type="submit" disabled={saveDis}></Button>
                    <Button className="field col-12 md:col-6 p-button-outlined h-2rem" label="CLOSE" onClick={onHide} type="button"></Button>
                </div>
            </form>
        </Dialog>
    );
}
